import type { RootState } from 'store';
import { createSelector } from 'reselect';
import { Brand } from 'app/auth/types';
import { BrandMarkets } from 'constants/enumTypes1';

const emptyBrands: Brand[] = [];

export const selectAuthUser = (state: RootState) => state.auth.user;
export const selectAuthUserFullName = (state: RootState) => {
  const user = selectAuthUser(state);
  return user ? `${user.firstName} ${user.lastName}` : '';
};
export const selectAuthUserPartnerAccesses = (state: RootState) => state.auth?.partnerAccesses;
export const selectAuthenticatedStatus = (state: RootState) => state.auth?.isAuthenticated;
export const selectAuthUserPartnerId = (state: RootState) => selectAuthUser(state)?.company?.id;
export const selectAuthUserId = (state: RootState) => selectAuthUser(state)?.id;
export const selectAuthIsTFAEnabled = (state: RootState) => state.auth?.isTFAEnabled;
export const selectUserPermissions = (state: RootState) => selectAuthUser(state)?.permissions;
export const selectAuthIsPasswordExpired = (state: RootState) => state.auth?.isPasswordExpired;
export const selectAuthTokenState = (state: RootState) => state.auth?.isTokenChanged;

const selectUserClaims = (state: RootState) => selectAuthUser(state)?.userClaims;
export const selectHasClaimType = createSelector([selectUserClaims, (_state: RootState, type) => type], (userClaims, type) => userClaims?.includes(type));
export const selectUserPartnerAccessIds = (state: RootState) => selectAuthUser(state)?.partnerAccessIds;

export const selectUserBrands = (state: RootState): Brand[] => selectAuthUser(state)?.brands ?? emptyBrands;

export const selectHasBrandsByMarket = createSelector([selectUserBrands, (_state: RootState, market: BrandMarkets) => market], (brands, market) => brands.some(({ market: brandMarket }: Brand) => brandMarket === market));

export const selectBrandsByMarket = createSelector([selectUserBrands, (_state: RootState, market:BrandMarkets) => market], (brands, market) => brands.filter(({ market: brandMarket }: Brand) => brandMarket === market));
